import Button from '@components/Button';
import Card from '@components/Card';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { OrderLine } from '@models/order';

import useModifyCartItem from './hooks/useModifyCartItem';
import styles from './styles.module.scss';

interface Props {
    item: OrderLine;
}

function CartItem({ item }:Props) {
  const {
    itemName, defaultOptions, personalOptions, quantity, totalAmount, itemImageUrl, status,
  } = item;
  const { handleDecrease, handleIncrease, handleDelete } = useModifyCartItem(item);
  const { itemMaxQuantity } = useAppCustom().item;
  const options = [...personalOptions, ...defaultOptions]
    .map((optionGroup) => optionGroup.options)
    .flat();
  const isSoldOut = status === 'SOLD_OUT';
  const disabled = status === 'PENDING' || status === 'DISCONTINUED';
  return (
      <Column fullWidth
              className={styles.container}
              spacing={10} >
          <Row spacing={16} align='flex-start' fullWidth>
              <Card className={styles.img}>
                  <Image src={itemImageUrl}
                         width={100}
                         height={100}
                         alt='상품 이미지' />
                  {isSoldOut && (
                      <div className={styles.soldoutWrapper}>
                          <div className={styles.soldoutContainer}>
                              <div className={styles.soldout} />
                              <Text size='s' fontWeight='bold'
                                    className={styles.soldoutText} >
                                  SOLDOUT
                              </Text>
                          </div>
                      </div>
                  )}
                  {disabled && (
                      <Disabled>
                          <Text color={colors.white} fontWeight='bold' align='center'>
                              판매 종료
                          </Text>
                      </Disabled>
                  )}
              </Card>
              <Column className={styles.text} spacing={10}>
                  <Column>
                      <Text size='lg' color={isSoldOut ? colors.gray5 : colors.gray6} fontWeight='bold'>
                          {itemName}
                      </Text>
                      <Text color={isSoldOut ? colors.gray5 : colors.gray6} size='lg'>
                          {options.map((option) => {
                            if (option.optionPrice) {
                              return `${option.optionName}(${option.quantity}개)(+${option.optionPrice.toLocaleString()}원)`;
                            }
                            return `${option.optionName}(${option.quantity}개)`;
                          }).sort().join(' | ')}
                      </Text>
                  </Column>
                  <Text color={isSoldOut ? colors.gray5 : colors.gray6} >
                      <b>{totalAmount.toLocaleString()}</b>원
                  </Text>
              </Column>
          </Row>
          <Row fullWidth justify='space-between'>
              <div className={styles.stepper}>
                  <Stepper value={quantity}
                           max={itemMaxQuantity}
                           min={1}
                           increase={handleIncrease}
                           decrease={handleDecrease} />
              </div>
              <Button className={styles.button}
                      onClick={handleDelete}>
                  삭제
              </Button>
          </Row>
      </Column>
  );
}

const Disabled = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default CartItem;
